/* unplugin-vue-components disabled */import { render } from "./simple-footer.vue?vue&type=template&id=14b9a3b4&scoped=true&ts=true"
import script from "./simple-footer.vue?vue&type=script&lang=ts"
export * from "./simple-footer.vue?vue&type=script&lang=ts"

import "./simple-footer.vue?vue&type=style&index=0&id=14b9a3b4&lang=less&scoped=true"

import exportComponent from "/Users/fiture/Fiture/officialwebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b9a3b4"]])

export default __exports__